<template>
<div id="email-recipients">
  <h2>{{ recipientType }} Recipients</h2>

  <newsletter-nav
    :emailId="emailId"
    :page_order_by="orderBy"
    v-if="isNewsletter"
  ></newsletter-nav>

  <email-nav
    :emailId="emailId"
    v-if="emailId"
  />

  <email-recipient-search
    :emailId="emailId"
    :newsletterId="newsletterId"
    :orderBy="orderBy"
  />

  <hr />

  <email-recipient-status-key
    ref="statusKey"
  />

  <pagination
    ref="pagination"
    :pageResponse="pageResponse"
    :pageSize="$root.defaultPageSize"
    :resourceUrl="resourceUrl"
    :orderBy="this.orderBy"
    orderType="DESC"
    preserveHistory
  >
    <template
      slot="pagination_hdr"
      slot-scope="items"
    >
    </template>
    <template
      slot="paged_item"
      slot-scope="item"
      >
      <router-link
        :class="$root.listItemClasses + 'recipient ' + $refs['statusKey'].recipientClass(item)"
        :to="{
          name: recipientRoute,
          params: recipientParams(item)
        }"
      >
        {{ item.recipient_email }} ({{ $root.displayDateTimeFmt(item.queued_at) }})
      </router-link>
    </template>
  </pagination>

  <email-recipients-actions
    :emailId="emailId"
    :newsletterId="newsletterId"
  />

</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import EmailNav from '@/components/EmailNav'
import NewsletterNav from '@/components/NewsletterNav'
import EmailRecipientsActions from '@/components/EmailRecipientsActions'
import EmailRecipientSearch from '@/components/EmailRecipientSearch'
import EmailRecipientStatusKey from '@/components/EmailRecipientStatusKey'
import EmailStats from '@/components/EmailStats'

import EmailMixin from '@/mixins/EmailMixin'

export default {
  data () {
    return {
      orderBy: 'created_at',
      pageResponse: undefined,
      recipients: []
    }
  },

  components: {
    'email-nav': EmailNav,
    'newsletter-nav': NewsletterNav,
    'email-recipients-actions': EmailRecipientsActions,
    'email-recipient-search': EmailRecipientSearch,
    'email-recipient-status-key': EmailRecipientStatusKey,
    'email-stats': EmailStats,
    pagination: Pagination
  },

  computed: {
    id () {
      return this.emailId || this.newsletterId
    },

    isNewsletter () {
      return this.newsletterId
    },

    recipientType () {
      return this.isNewsletter ? 'Newsletter' : 'Email'
    },

    resourceUrl () {
      return this.apiUrl(
        (this.emailId || this.newsletterId) ? (
          `/${this.emailId ? 'targeted_emails' : 'newsletters'}/` + this.id + '/recipients'
        ) : '/email_recipients',
        true
      )
    }
  },

  mixins: [ EmailMixin ],

  created () {
    this.$on('searchComplete', this.onPageSuccess)
  },

  mounted () {
    this.$refs['statusKey'].$on('statusTypeSelected', this.changeOrderBy)
  },

  methods: {
    changeOrderBy (status) {
      this.orderBy = status

      this.$emit('changeConfig', {
        page_order_by: this.orderBy
      })
      this.$emit('requestPage')
    },

    onPageSuccess (response) {
      this.pageResponse = response
    }
  }

}
</script>





// WEBPACK FOOTER //
// src/components/EmailRecipients.vue